import { gql } from '@apollo/client';

/**
 * ТЗ 0093 — запись runtime-настроек. Имена операций ≠ полям бэкенда.
 *
 * Ответ `setRuntimeSetting` / `clearRuntimeSetting` несёт ключ целиком
 * (`RuntimeSettingFields`) — Apollo пишет его в кэш по `key`, и строка на
 * экране обновляется без `refetchQueries` по имени. `value` на входе —
 * JSON-текст (`JSON.stringify(value)`).
 */

export const SetRuntimeSettingValueMutation = gql`
  mutation SetRuntimeSettingValue(
    $key: String!
    $value: JSONString!
    $reason: String
  ) {
    setRuntimeSetting(key: $key, value: $value, reason: $reason) {
      success
      changed
      customErrors {
        field
        code
        message
      }
      setting {
        ...RuntimeSettingFields
      }
    }
  }
`;

export const ClearRuntimeSettingValueMutation = gql`
  mutation ClearRuntimeSettingValue($key: String!, $reason: String) {
    clearRuntimeSetting(key: $key, reason: $reason) {
      success
      changed
      customErrors {
        field
        code
        message
      }
      setting {
        ...RuntimeSettingFields
      }
    }
  }
`;

export const DisableOrphanPeriodicTaskActionMutation = gql`
  mutation DisableOrphanPeriodicTaskAction($name: String!, $reason: String) {
    disableOrphanPeriodicTask(name: $name, reason: $reason) {
      success
      changed
      customErrors {
        field
        code
        message
      }
      orphan {
        name
        task
        enabled
        schedule
        lastRunAt
        totalRunCount
      }
    }
  }
`;
